import React from 'react';
import '../style/Teaching.scss';
// react bootstrap
import { Container } from 'react-bootstrap';
import Header from '../components/public/Header';

function Teaching1() {
  return (
    <>
      <Header />
      <Container>
        <div className='content'>
          <h3 className='text-left text-secondary'>如何運行氣</h3>
          <p className='chineseParagraph'>
            氣形成起源於受精卵結合前，此時存在的一種氣也就是人的最細明點。在最細的層面而言,宇宙的物理規律及轉生的業力。規律皆各別成立於一種相續之上,也就是逐步發展成形的虛空極微相續及最細明點相續。從宇宙世界的觀點來說,就是極微之間的虛空,若就人類的轉生來說,便是能量系統的微細明點。五種根本氣與五種分支氣。內在的某些氣我們一般感覺不到，但實際上卻是存在七萬兩千條的脈在流動著氣。在世俗諦當中，這些氣可以維持我們的身體，一旦這些氣出了問題，或者是失去了，身體就會受到不同程度的影響。氣有很多種，最粗大的、最外在的，是我們的呼吸。按照時輪金剛計算出的日食、月食等等在內的宇宙所有運動的基礎資料得知每分鐘有十五次呼吸，一個健康的中年人每天有21600次呼吸（一呼一吸為一個數）。這個結果，與現代醫學的觀點基本吻合。因此，在人臨近死亡的時候，首先氣會出現日漸衰竭、停滯，雖然我們感覺不到，但由於氣與精神是密切相關的，所以在身體的某些局部、夢境當中或者情緒上面就會出問題。雖然間隔死亡時間因人而異有時長有時短，但都是死亡的徵兆。深層次的密氣，是指精神的運動，雖然阿賴耶識沒有很明顯的運動，但從阿賴耶識上面產生的精神卻有著明顯的波動——誕生、延續與滅亡，這種波動也叫氣。業氣與智慧氣。業氣是指普通人的呼吸。有了呼吸的氣流以後，就會讓我們產生各種各樣的煩惱或念頭——善的念頭、惡的念頭、無記的念頭，所有念頭都與呼吸有著密切的內在關係，所以稱之為業氣。智慧氣也叫做智氣，也即氣（呼吸）當中產生智慧的那一部分。
          </p>
        </div>
      </Container>
    </>
  );
}

export default Teaching1;
